import styled from 'styled-components';

export const ActionGroup = styled.div({
	justifyContent: 'flex-end',
	display: 'flex',
	width: '100%',
});
